import moment from 'moment-timezone';

export const isSameDay = (
  first: moment.Moment,
  second: moment.Moment,
): boolean => first.format('YYYY-MM-DD') === second.format('YYYY-MM-DD');
